'use strict';
module.exports = require('../../full/instance/concat');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/instance/concat.js
// module id = 592
// module chunks = 13